(function (angular) {
  "use strict";

  soberTime.$inject = ["$interval", "timeAgoFilter"];

  /**
   * Angular directive that renders a sentence informing how long ago a date occurred.
   *
   * @note null dates, or dates than occurred more than 1 month ago will always output the string
   * "more than a month ago" as per client request.
   *
   * @example
   * <span sober-time="updatedAt"></span>
   * might become
   * "about 20 hours ago"
   *
   * <span sober-time="createdAt"></span>
   * might become
   * "more than a month ago"
   */
  function soberTime($interval, timeAgoFilter) {
    function link($scope, $element) {
      if (!$scope.soberTime) {
        $scope.time_ago = "more than a month ago";
        return false;
      }

      // check if under 30 days before using timeAgo
      const now = window.moment();
      const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const dateTime = window.moment($scope.soberTime).tz(userTimezone);
      const monthsAgo = now.diff(dateTime, "months", true); // Use diff with 'months' for precise calculation

      if (monthsAgo >= 1) {
        $scope.time_ago = "more than a month ago";
      } else {
        const postStr = dateTime.isBefore(now) ? " ago" : "";

        // Set time ago for the first time
        $scope.time_ago = timeAgoFilter(dateTime.toDate()) + postStr;

        // Update the time every second
        const stop = $interval(() => {
          $scope.time_ago = timeAgoFilter(dateTime.toDate()) + postStr;
        }, 1000);

        // Cancel the interval on scope destroy
        $scope.$on("destroy", () => {
          $interval.cancel(stop);
        });

        // Set the element's title attribute to the user's local time string
        $element.attr("title", dateTime.toDate().toLocaleString());
      }
    }

    return {
      link,
      restrict: "A",
      scope: {
        /**
         * Value that can be passed to the moment constructor.
         *
         * @var {Date | number | string | Moment} soberTime
         */
        soberTime: "=",
      },
      template: "{(time_ago)}",
    };
  }

  angular.module("app").directive("soberTime", soberTime);
})(angular);
